import { render, staticRenderFns } from "./WHVideo.vue?vue&type=template&id=3ce8c8ac&scoped=true"
import script from "./WHVideo.vue?vue&type=script&lang=js"
export * from "./WHVideo.vue?vue&type=script&lang=js"
import style0 from "./WHVideo.vue?vue&type=style&index=0&id=3ce8c8ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_85bb6ef93cf5a779f9b064f420832c70/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce8c8ac",
  null
  
)

export default component.exports